import React, { useEffect, useState, useRef } from 'react'
import useApp from 'hooks/useApp'
import { Link, useNavigate } from 'react-router-dom'
import styles from './index.module.css'
import { Button, LayerBottom, Scroller } from 'components'

const MemberIntro = () => {

	const App = useApp()
	const navigate = useNavigate()
	const scroller = useRef()
	const [authorityLayer, setAuthorityLayer] = useState(false)
	const [buttonDisabled, setButtonDisabled] = useState(true)

	let interval

	const closeAuthorityLayer = () => {
		setAuthorityLayer(false)

		// [슬라이드팝업이 닫힌 후 setTime 함수가 시작되도록 수정. 20221123]
		interval = setInterval(() => {
			//console.log('setTime');
			if (!scroller.current) {
				clearInterval(interval)
				return
			}
			const now = scroller.current.getCurrent()
			console.log('now='+now)
			if (now < 4) {
				scroller.current.slideRight()
			} else {
				clearInterval(interval)
			}
		}, 5000)
	}

	const goNext = () => {
		if (interval) clearInterval(interval)
		navigate("/termsCheck")
	}

	const callback = (n) => {
		setButtonDisabled(n !== 4)
	}

	useEffect(() => {
		App.setShowHeader(false)

		App.setShowNav(false)
		App.setMainClass("white")

		setTimeout(() => {
			setAuthorityLayer(true)
		}, 1000)

		/*	// setTime이관
		interval = setInterval(() => {
			if (!scroller.current) {
				clearInterval(interval)
				return
			}
			const now = scroller.current.getCurrent()
			console.log('now='+now)
			if (now < 4) {
				scroller.current.slideRight()
			} else {
				clearInterval(interval)
			}
		}, 5000)
		*/
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding center-cont px_0">
				<div className="slider">
					<Scroller ref={scroller} full={true} callback={callback}>
						<li className="flex-column justify_center">
							<div className={styles["member-intro-img01"]} />
							<hr className="mx_20 my_30" />
							<h3 className="intro-tit text-blue">하나의 앱으로 내 정보를 한눈에</h3>
							<p className="intro-sub-tit mt_10">내 자산 관리 어렵지 않아요!<br />
								쉽고 빠르게 회원가입하고 필요한 정보들만<br />
								쏙쏙 골라서 볼 수 있는 앱
							</p>
						</li>
						<li className="flex-column justify_center">
							<div className={styles["member-intro-img02"]} />
							<hr className="mx_20 my_30" />
							<h3 className="intro-tit text-blue">유사그룹과의 비교 가능한 똑똑한 분석가</h3>
							<p className="intro-sub-tit mt_10">내 정보를 바탕으로 유사그룹과 비교분석하여<br />
								현재 내위치를 분석해 볼 수 있는 똑똑한 분석가<br />
								나만의 매니저라구요!
							</p>
						</li>
						<li className="flex-column justify_center">
							<div className={styles["member-intro-img03"]} />
							<hr className="mx_20 my_30" />
							<h3 className="intro-tit text-blue">내가 받을 수 있는 혜택은?</h3>
							<p className="intro-sub-tit mt_10">금융, 생활, 라이프, 추천, 지원금 등…<br />
								여러가지 모든 혜택을 한눈에!<br />
								모니에 다있so!
							</p>
						</li>
						<li className="flex-column justify_center">
							<div className={styles["member-intro-img04"]} />
							<hr className="mx_20 my_30" />
							<h3 className="intro-tit text-blue">내 정보를 쉽고 빠르게 공유</h3>
							<p className="intro-sub-tit mt_10">핸드폰만 있다면 언제 어디서나 쉽고<br />
								빠르게 내가 원하는 정보를 공유할 수 있는<br />
								만능 엔터테이너! 넌 도대체 모니~?
							</p>
						</li>
					</Scroller>
					{/* <ul className="slider-dots dots-gray" style={{ marginTop: "14rem" }}>
						<li className="active" />
						<li />
						<li />
						<li />
					</ul> */}
				</div>
			</div>
			<div className="padding flex-shrink_0">
				<Button className="btn btn--big" disabled={buttonDisabled} onClick={goNext}>시작하기</Button>
			</div>

			<AuthorityLayer show={authorityLayer} closeLayer={closeAuthorityLayer} />
		</div>
	)
}

const AuthorityLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom title="권한설정 안내" show={show} closeLayer={closeLayer} closeButton={false} outside={
			<Button className="btn btn--big btn-layer" onClick={closeLayer}>확인</Button>
		}>
			<ul className="terms-list">
				<li>
					<div className="chk">
						<i className="" />
						<label htmlFor="check1">
							<span><strong>[필수]</strong> 저장공간</span>
						</label>
					</div>
					<span className="terms-guide">기기 내 저장된 파일 및 기기의 외부 저장소 사용 공유 저장공간의 컨텐츠 읽기</span>
				</li>
				<li>
					<div className="chk">
						<i className="" />
						<label htmlFor="check2">
							<span><strong className="gray">[선택]</strong> 푸시알람</span>
						</label>
					</div>
					<span className="terms-guide">모니에서 제공하는 알림 수신</span>
				</li>
				<li>
					<div className="chk">
						<i className="" />
						<label htmlFor="check3">
							<span><strong className="gray">[선택]</strong> Touch ID / Face ID</span>
						</label>
					</div>
					<span className="terms-guide">로그인 및 연동 등 서비스에서 사용자 인증을 위하여 이용</span>
				</li>
			</ul>
			<div className="terms-box mt_20">
				<p>※ 선택적 접근 권한은 동의하지 않으셔도 앱 이용이 가능하며, 해당 기능 이용 시 동의를 받습니다.</p>
				<p className="mt_20">※ 접근권한 변경방법 [설정-모니앱-권한 ON/OFF]</p>
			</div>
		</LayerBottom>
	)
}

export default MemberIntro
